import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PhxBaseDetailSaveButtonComponent } from "../../../../shared/components/phx-base-detail-save-button/phx-base-detail-save-button.component";
import { BlockableDiv } from "../../../../shared/controls/blockable-div/blockable-div.component";
import { WidgetSetMenuToRoleComponent } from "./widget-set-menu-to-role.component";

@Component({
  selector: 'app-formly-set-menu-to-role',
  imports: [
    BlockableDiv,
    WidgetSetMenuToRoleComponent,
    PhxBaseDetailSaveButtonComponent,
    TranslatePipe
  ],
  template: `
    <blockable-div [blocked]="!model?.id" [blockUi]="blockUi">
      @defer (when model?.id) {
          <app-widget-set-menu-to-role
            [selectedRole]="model"
            [showRoleDropdown]="false"
          />
        }
    </blockable-div>

    <ng-template #blockUi>
        <app-phx-base-detail-save-button
          [baseDetailComponent]="formState.detailComponent"
          [saveButtonLabel]="'common.save' | translate"
        />
    </ng-template>
  `,
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlySetMenuToRoleComponent extends FieldType<FieldTypeConfig> { }
